export function elementHasAllPermissions(authUserPermissions, elementPermissions){
  const missingPermissions = elementPermissions.filter(permission => {
    if(!permission || !permission.length)
      return true;

    const alternatePermissions = permission.split('|').map(permission => permission.trim());
    if(alternatePermissions.length > 1){
      const matchingAlternates = alternatePermissions.filter(alternatePermission => {
        return authUserPermissions.indexOf(alternatePermission) !== -1;
      });

      return matchingAlternates.length == 0;
    }
    else
      return authUserPermissions.indexOf(permission) === -1;
  });

  return missingPermissions.length == 0;
}

export default function(authUserPermissions){
  return {
    inserted: function (el, binding) {
      const elementPermissions = binding.value;
      if(!elementPermissions || !elementPermissions.length)
        return;

      if(!elementHasAllPermissions(authUserPermissions, elementPermissions))
        el.style.display = "none";
    }
  }
}
